import { useContext, useState } from 'react';
import * as React from 'react';
import {observer} from "mobx-react";
import {StoreContext} from "../../stores/StoreLoader";
import ClickableLink from "./ClickableLink";
import styles from './styles/ThirdPartyIframe.module.scss';
import FontAwesome from "./FontAwesome";
import Button from "./Button";

interface ThirdPartyIframeProps extends React.ComponentPropsWithRef<"iframe"> {
    contentUrl: string,
    errorOnCrossSiteTracking: boolean,
}

const ThirdPartyIframe: React.FC<ThirdPartyIframeProps> = observer(props => {
    const {interfaceStore} = useContext(StoreContext);
    const [popupOpen, setPopupOpen] = useState(true);

    const { contentUrl, errorOnCrossSiteTracking, ...remainingProps } = props;

    return <>
        <iframe {...remainingProps} />
        {(errorOnCrossSiteTracking && !interfaceStore.thirdPartyCookiesEnabled && popupOpen) && <div className={styles.container}>
            <Button onClick={() => setPopupOpen(false)}>
                <FontAwesome prefix={'fas'} name={'fa-times'} />
            </Button>
            <div className={"sb-error-inside-block"}>
                <FontAwesome prefix={'far'} name={'fa-frown'} className={"sb-error-inside-block-icon"} />
                <div className={"sb-error-inside-block-header"}>
                    <h2>Aww, snap!</h2>
                </div>
                <p className={"sb-error-inside-block-message"} style={{textAlign: 'center'}}>
                    <ClickableLink href={contentUrl}>View Original Content</ClickableLink>
                </p>
                <p className={"sb-error-inside-block-message"}>
                    This content is unavailable because of your
                    browser's privacy settings. SchoolBlocks, the host of this website, feels that your
                    browser's privacy settings are just right!  While we work to find a safe way for you
                    to view this content, please feel free to view the content by clicking the button above.
                </p>
            </div>
            <small><ClickableLink href={"https://docs.google.com/document/d/1ED16obTj_bVeuXWn9F_tJaXfqJ6C8A_gmYEIOlEDL6w"}>More information on why you're seeing this error message</ClickableLink></small>
        </div>}
    </>
});

export default ThirdPartyIframe;
